module.exports = "<p>\r\n  mayoristas-comunicados works!\r\n</p>\r\n"